import React from "react";
import NavBar from "../components/NavBar";
import BuyAPropertyPage from "../components/BuyAPropertyPage";
import Footer from "../components/Footer";

const BuyAProperty = () => {
    return(
        <div>
            <NavBar/>
            <BuyAPropertyPage/>
            <Footer/>
        </div>
    )
}

export default BuyAProperty;